<style>
.bg-gray{
  background-color: #d9d9d9;
  
}
.product-a{
  color:#000000;
}
.product-a:hover{
  color:#003567;
  text-decoration:none;
}
.center-vertical{

  position: relative;

  top: 50%;

  transform: translateY(-50%);

  }

@media screen and (min-width:576px) {
  .book{
    -webkit-writing-mode: vertical-rl;
    -ms-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    margin:0 auto;
  }
}
@media (min-width:576px) and (max-width:992px) {
  .book{
    margin-top: -20px;
  }
}
.book_h{
  height: 280px;
}
@media screen and (max-width:576px) {
  .book_h{
    height: 125px;
  }
}
@media screen and (min-width:992px) {
  .book_m{
    margin-top: 20%;
  }
}
@media (min-width:576px) and (max-width:992px) {
  .book_m{
    margin-top: 35%;
  }
}
.product_b{
  font-size: 24px;
}
.product_b1{
  font-size: 20px;
}
@media screen and (max-width:576px) {
  .product_b1{
    font-size: 24px;
  }
}
.cube_transform{
  transition: transform 0.35s;
  -moz-transition: transform 0.35s;	/* Firefox 4 */
  -webkit-transition: transform 0.35s;	/* Safari 和 Chrome */
  -o-transition: transform 0.35s;
}
.cube_transform:hover{
  transform:scale(1.05,1.05);
}
.straight_h{
  height: 350px;
}
.horizontal_h{
  height: 160px;
}
@media screen and (max-width:1200px) {
  .straight_h{
    height: 280px;
  }
  .horizontal_h{
    height: 125px;
  }
}
.block1 svg{
    font-size: 75px;
    opacity: 0.8;
}
.block1 {
    line-height: 30px;
}
.product-a:hover{
  color:#003567;
  text-decoration:none;
}
.product-a{
  color:#000000;
}
.h_title{
  -webkit-writing-mode: vertical-rl;
  writing-mode: vertical-rl;
  font-size: 40px;
}

@media screen and (max-width:1199px) {
  .h_title{
    font-size: 30px;
  }
}
</style>

<template>
    <div>
        <router-view ></router-view>
        <div class="container" style="font-family:Microsoft JhengHei " v-if="product">
            <div class="row ">
                <div class="col-12 col-lg-6 p-3">
                    <div class=" bg-info straight_h">
                        <div class="p-5 text-white">
                            <h2>產品介紹</h2>
                            <p class="ml-2 mt-4">- 淺顯易學之圖形化，縮短人員操作時間</p>
                            <p class="ml-2">- 系統功能彈性化，可依實際須求客制化</p>
                        </div>
                    </div>

                </div>

                <div class="col-12 col-sm-4 col-lg-2">
                    <center>
                        <div class="row p-3">
                            <div class="col-12 bg-gray straight_h cube_transform">
                                <div class="center-vertical">
                                    <router-link to="/product/phone" class="product-a">
                                        <div class="block1 row">
                                            <div class="text-center w-75 h-45 col-sm-12 col book_m">
                                                <i class="fas fa-mobile-alt"></i>
                                            </div>
                                            <div width="100%" class="col-sm-3 col p-1 text-center product_b book">
                                                <b class="text-center">行動裝置</b>
                                            </div>

                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </center>
                </div>
                <div class="col-12 col-sm-8 col-lg-4">
                    <center>
                        <div class="row p-3" style="padding-bottom:15px!important;">

                            <div class="col-12  bg-gray cube_transform horizontal_h">
                                <div class="center-vertical">
                                    <router-link to="/product/hotel" class="product-a">
                                        <div class="block1 row">
                                            <div class="col-6 p-1 text-right product_b">
                                                <b>飯店PMS</b>
                                            </div>
                                            <div class="w-75 h-45 col">
                                                <i class="fas fa-hotel"></i>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>

                        </div>
                        <div class="row  p-3 " style="padding-top:15px!important;">

                            <div class="bg-gray col-12 cube_transform horizontal_h">
                                <div class="center-vertical">
                                    <router-link to="/product/pos" class="product-a">
                                        <div class="block1 row">
                                            <div class="w-75 h-45 col-5">
                                                <i class="fas fa-utensils"></i>
                                            </div>
                                            <div class="col p-1 text-left product_b">
                                                <b>餐廳POS</b>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>

                        </div>
                    </center>
                </div>
            </div>
            <center>
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="row">
                            <div class="col-12 col-sm-8 p-3">
                                <div class="bg-gray col-lg-12 cube_transform horizontal_h">
                                    <div class="center-vertical">
                                        <router-link to="/product/purchase" class="product-a">
                                            <div class="block1 row">
                                                <div class="col-6 p-1 text-right product_b">
                                                    <b>採購庫存</b>
                                                </div>
                                                <div class="text-center w-75 h-45 col">
                                                    <i class="fas fa-shopping-cart"></i>
                                                </div>

                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-4 p-3">

                                <div class="bg-gray col-12 cube_transform horizontal_h" >
                                    <div class="center-vertical">
                                        <router-link to="/product/booking" class="product-a">
                                            <div class="block1 row">
                                                <div class="text-center w-75 h-45 col-sm-12 col-5">
                                                    <i class="fas fa-calendar-alt"></i>
                                                </div>
                                                <div class="col-sm-12 col p-1 text-sm-center text-left product_b1">
                                                    <b>訂席系統</b>
                                                </div>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="row p-3">
                            <div class="col-12 bg-gray cube_transform horizontal_h">
                                <div class="center-vertical">
                                    <router-link to="/product/combine" class="product-a">
                                        <div class="block1 row">
                                            <div class="col-6 p-1 text-right product_b">
                                                <b>整合管理</b>
                                            </div>
                                            <div class="w-75 h-45 col">
                                                <i class="fas fa-cogs"></i>
                                            </div>

                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="col-12 col-sm-4 col-lg-2 ">
                        <div class="row p-3">
                            <div class="bg-gray  col-12 cube_transform horizontal_h" >
                                <div class="center-vertical">
                                    <router-link to="/product/humanresource" class="product-a">
                                        <div class="block1 row">
                                            <div class="text-center w-75 h-45 col-sm-12 col-5">
                                                <i class="fas fa-users"></i>
                                            </div>
                                            <div class="col-sm-12 col p-1 mt-sm-2 text-sm-center text-left product_b1">
                                                <b>人資管理</b>
                                            </div>

                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="row p-3">
                            <div class="bg-gray  col-12 cube_transform horizontal_h" >
                                <div class="center-vertical">
                                    <router-link to="/product/finance" class="product-a">
                                        <div class="block1 row">
                                            <div class="col-sm-12 col-6 p-1 text-sm-center text-right product_b1">
                                                <b>財務管理</b>
                                            </div>
                                            <div class="text-center w-75 h-45 col-sm-12 col ">
                                                <i class="fas fa-hand-holding-usd"></i>
                                            </div>

                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-4  col-lg-2 ">
                        <div class="row p-3">
                            <div class="bg-gray col-12  cube_transform horizontal_h" >
                                <div class="center-vertical">
                                    <router-link to="/product/fix" class="product-a">
                                        <div class="block1 row">
                                            <div class="text-center w-75 h-45 col-sm-12 col-5">
                                                <i class="fas fa-wrench"></i>
                                            </div>
                                            <div class="col-sm-12 col p-1  text-sm-center text-left product_b1">
                                                <b>工程維修</b>
                                            </div>

                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="row p-3">
                            <div class="bg-gray col-12 cube_transform horizontal_h" >
                                <div class="center-vertical">
                                    <router-link to="/product/securities" class="product-a">
                                        <div class="block1 row">
                                            <div class="col-sm-12 col-6 p-1 text-sm-center text-right product_b1">
                                                <b>票券管理</b>
                                            </div>
                                            <div class="text-center w-75 h-45 col-sm-12 col">
                                                <i class="fas fa-ticket-alt"></i>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-4  col-lg-2 ">
                        <div class="row p-3">
                            <div class="bg-gray  col-12 cube_transform horizontal_h" >
                                <div class="center-vertical">
                                    <router-link to="/product/sale" class="product-a">
                                        <div class="block1 row">
                                            <div class="text-center w-75 h-45 col-sm-12 col-5">
                                                <i class="fas fa-dolly-flatbed"></i>
                                            </div>
                                            <div class="col-sm-12 col  p-1 text-sm-center text-left product_b1">
                                                <b>商品銷售</b>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="row p-3">
                            <div class="bg-gray col-12  cube_transform horizontal_h" >
                                <div class="center-vertical">
                                    <router-link to="/product/member" class="product-a">
                                        <div class="block1 row">
                                            <div class="col-sm-12 col-6 p-1 text-sm-center text-right product_b1">
                                                <b>會員管理</b>
                                            </div>
                                            <div class="text-center w-75 h-45 col-sm-12 col">
                                                <i class="fas fa-user-circle"></i>
                                            </div>

                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </center>
        </div>
    </div>
    
</template>
<script>
export default {
    data(){
        return{
            product:false,
        }
    },
    mounted(){
        if (this.$route.path === "/product" || this.$route.path === "/product/") {
            this.product =true;
        }else{
            this.product = false;
        }
    },
    watch: {
        $route: function() {
            if (this.$route.path === "/product/") {
                
            }
            if (this.$route.path === "/product" || this.$route.path === "/product/") {
                this.product =true;
            }else{
                this.product = false;
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/product.vue